import { Component, OnInit, Input, Output, EventEmitter, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { DataService } from '../../../shared/dataservice.service';
import { PmCommercialIP, SalesOrder, SOStatus, SaveStatusObj, SOModule, SaveEventType, ActualDateChange, ActualDateToken, PlannedDateToken, ValidationItem, GenFileUploads, ValidationSummary } from '../../../shared/misc-classes';
import { ActualDateDialog } from '../../../dialogs/actual-date-dialog/actual-date-dialog';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog'
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar'
import { ValidationDialog } from '../../../dialogs/validation-dialog/validation-dialog';


@Component({
  selector: 'pm-commercial',
  templateUrl: './pm-commercial.component.html',
  styleUrls: ['./pm-commercial.component.css'],
  //changeDetection:ChangeDetectionStrategy.OnPush
})
export class PmCommercialComponent implements OnInit, OnChanges {
  @Input() pmCommercialObj: PmCommercialIP;
  @Input() soLockObtained:boolean;
  @Output() updateSalesOrder: EventEmitter<any> = new EventEmitter();
  @Output() showFileManager: EventEmitter<GenFileUploads> = new EventEmitter();

  disableForm:boolean = true;
  modifyPlanDate:boolean = false;
  inputDisableMessage:string = 'NA';
  Hvr:any = {};
  ssoData : string = '';
  ssoList:any =[];
  ssoModel='';

  constructor(public _dataService:DataService,public dialog: MatDialog, private _snackBar: MatSnackBar) { }
  ngOnInit() {
    this.modifyPlanDate = this._dataService.modifyPlanDate;
    this.ngOnChanges();

    let num = [];
    this.pmCommercialObj.SsoNos.forEach(e => {
      num.push(e);
    });
    for (var i = 0; i < num.length; i++) {
      this.ssoList.push({ num: num[i] });
    }    
    // this.pmCommercialObj = new PmCommercialIP("","","","","",null,null,"",null,null,"",null,null);
  }
  ngOnChanges(){
    this.disableForm = true;
    if(this.soLockObtained == false){
      this.inputDisableMessage = "You can't Edit, Sale Order Lock NOT obtained.";
    }
    else if(!this.pmCommercialObj.isInputEnabled){
      this.inputDisableMessage = "This form is not yet enabled";
    }
    else if (!this._dataService.hasPmCommercialEditAccess(this.pmCommercialObj)) {
      this.inputDisableMessage = "You don't have EDIT ACCESS.";
    }
    else {
      this.disableForm = false;
    }
    this.pmCommercialObj.abgUploads.disableUpload = this.disableForm;
    this.pmCommercialObj.abgUploads.headerStr = 'ABG Uploads'  + " - " + this.pmCommercialObj.parentSORef.marketingIP.salesOrderNo;
    this.pmCommercialObj.pbgUploads.disableUpload = this.disableForm;
    this.pmCommercialObj.pbgUploads.headerStr = 'PBG Uploads' + " - " + this.pmCommercialObj.parentSORef.marketingIP.salesOrderNo;
    
  }
  deleteSo(_deleteSO:boolean){
    if(this.updateSalesOrder){
      this.updateSalesOrder.emit(new SaveStatusObj(SOModule.PM_Commercial, SaveEventType.Delete_Sale_Order));
    }
  }
  actualDateChangeHandler(_actDateHeader:string,_actDate:Date,_actDateChanged:Date,_actTokenKeyName:string,_plndDateHeader:string,
                          _plndDate:Date):void{
    let _actDateChangeObj:ActualDateChange = new ActualDateChange("Additional Comment", _plndDateHeader, _plndDate, _actDateHeader, 
                                                              _actDateChanged, this.pmCommercialObj[_actTokenKeyName].addNotes);
    let dialogRef = this.dialog.open(ActualDateDialog, {
      width: '50%',
      data: _actDateChangeObj
    });
    let _prevActualDate:Date = this.pmCommercialObj[_actTokenKeyName].actualDate;
    this.pmCommercialObj[_actTokenKeyName].actualDate = _actDateChanged;
    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm == true) {
        this.pmCommercialObj[_actTokenKeyName].actualDate = _actDateChangeObj.actualDate;
        var changedDate: Date = null;
        if(_actDateChangeObj.actualDate != null){
          changedDate = new Date(_actDateChangeObj.actualDate.getTime());
        }
        this.pmCommercialObj[_actTokenKeyName] = 
          new ActualDateToken(changedDate, true, _plndDate, _actDateChangeObj.comments,this._dataService.userId);
      }
      else {
        this.pmCommercialObj[_actTokenKeyName].actualDate = _prevActualDate;
      }
    });
  }

  plannedDateChangeHandler(_plndDateHeader:string, _plndTokenKeyName:string,_plndDate:Date,_plndDateChanged:Date):void{
    let _plndDateChangeObj:ActualDateChange = new ActualDateChange("Why is the planned date changed ?", _plndDateHeader + "(existing)", 
                                                  _plndDate, _plndDateHeader + "(edited)", _plndDateChanged, this.pmCommercialObj[_plndTokenKeyName].addNotes);
    let dialogRef = this.dialog.open(ActualDateDialog, {
      width: '50%',
      data: _plndDateChangeObj
    });
    this.pmCommercialObj[_plndTokenKeyName].plannedDate = _plndDateChanged;
    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm == true) {
        this.pmCommercialObj[_plndTokenKeyName] = 
          new PlannedDateToken(new Date(_plndDateChanged.getTime()), true, null, _plndDateChangeObj.comments,this._dataService.userId);
      }
      else {
        this.pmCommercialObj[_plndTokenKeyName].plannedDate = _plndDate;
      }
    });
  }

  saveSo(_submitToNextSection:boolean){
    if(this.updateSalesOrder){

      this.updateSalesOrder.emit(new SaveStatusObj(SOModule.PM_Commercial, 
          (_submitToNextSection == true ? SaveEventType.Submit_To_Next:SaveEventType.Save_Data)));
    }
  }

  saveSo2(_submitToNextSection:boolean){
    if(this.updateSalesOrder){

      this.updateSalesOrder.emit(new SaveStatusObj(SOModule.PM_Commercial, 
          (_submitToNextSection == true ? SaveEventType.Submit_To_Next:SaveEventType.Save_ChangeData)));
    }
  }

  reloadData(){
    if(this.updateSalesOrder){
      this.updateSalesOrder.emit(new SaveStatusObj(SOModule.Marketing, SaveEventType.Reload_Data));
    }
  }
  ABGUploadsFileManagerClick(_evnt:any){
    _evnt.stopPropagation();//stop ref
     this.showFileManager.emit(this.pmCommercialObj.abgUploads);
  }
  PBGUploadsFileManagerClick(_evnt:any){
    _evnt.stopPropagation();//stop ref
     this.showFileManager.emit(this.pmCommercialObj.pbgUploads);
  }
  onSSOChange(_eventSso){    
    this.ssoData = _eventSso.value;
  }
  GenerateCallLetterClick(_evnt:any){
    this.pmCommercialObj.addFatData(this.pmCommercialObj.fatCallLetterDate,this.ssoData,this._dataService.userName);
    this.ssoModel = '';
    this.saveSo2(false);

    let nowDate = this._dataService.getFullDateFormat(new Date());

    let fatDate = this._dataService.getFullDateFormat(this.pmCommercialObj.fatCallLetterDate);

    let poDate = this._dataService.getFullDateFormat(this.pmCommercialObj.pmPoDate);
   
    let ssoString = this.pmCommercialObj.parentSORef.marketingIP.salesOrderNo+" - ";
    var _tmpSso = this.ssoData;
    for (let i = 0; i < _tmpSso.length; i++) {
      let _data = _tmpSso[i];
      if(i > 0 && i <= _tmpSso.length-1){
        ssoString+= "/ ";
      }
      ssoString+=_data;
    }

    let fileString = this.pmCommercialObj.parentSORef.marketingIP.salesOrderNo+" - ";
    var _tmpfile = this.ssoData;
    for (let i = 0; i < _tmpfile.length; i++) {
      let _data = _tmpfile[i];
      if(i > 0 && i <= _tmpfile.length-1){
        fileString+= "_";
      }
      fileString+=_data;
    }

    let _tmpEqp = this.getEqpPanel(this.ssoData, 1);
    let _tmpPanel = this.getEqpPanel(this.ssoData, 2);

    var _data = {"fileName":fileString,"customer": this.pmCommercialObj.parentSORef.marketingIP.customerName, "date":nowDate, "pmName":this._dataService.getProjectEngineerName(this.pmCommercialObj.projectEngineerId), "so":ssoString, "newso": this.pmCommercialObj.parentSORef.pmCommercial.salesOrderNoNew ? this.pmCommercialObj.parentSORef.pmCommercial.salesOrderNoNew : "-",
      "custpo": this.pmCommercialObj.customerPoNo? this.pmCommercialObj.customerPoNo : "", "poDate": poDate , "proj":this.pmCommercialObj.parentSORef.marketingIP.projectName, "fatDate": fatDate ,"eqp":_tmpEqp, "panel": _tmpPanel ,"workDays":this.pmCommercialObj.workDaysNo? this.pmCommercialObj.workDaysNo : "-"};

     
    this._dataService.downloadPdfFunc(_data).subscribe((_docid: any) => {
      if (_docid.status == "OK") {
        let mailData = {};
        let _tmpBody = "Dear Sir / Madam,<br><br> Hereby we are offering the Factory Acceptance Test for the subject job. Please find attached FAT Letter.<br><br>"+
        "<br><strong> Project Name : </strong> "+ this.pmCommercialObj.parentSORef.marketingIP.projectName+"<br><br><strong> Equipment Offered :</strong> "+ _tmpEqp +"<br><br><strong> Inspection Date : </strong> "+fatDate+"<br><br>"+
        "Request you to confirm the mode of inspection, no of participants, Details of participants - Name, Organization name, Email Ids, Phone nos.<br>"+
        "Details are required to create gate pass at our plant to allow smooth entry of the visitors.<br><br><br>"+
        "Thanks & Regards";

        mailData = { "toMail": [this._dataService.userId], "mailBody": _tmpBody, "ccMail":[], "subMail":"FAT Call Letter : "+ fileString +" - "+this.pmCommercialObj.parentSORef.marketingIP.customerName,
        "filenames": [], "trigger": "", "status": "","imageFile":[{ fpath: _docid.data.filename, fname: _data.fileName+'.pdf', ftype: 'application/pdf'}],"unlink":true};

        this.uploadPdfFile(mailData);
      }
      
    });
  }

  sendMail( _mailData){
    this._dataService.sendaisc40(_mailData).subscribe((_docid: any) => {
        if(_docid.status != "OK"){
          this._snackBar.open("Failed to Send Mail Notification", "Dismiss", {
            duration: 6000,
          });
                        
        }
        else {
          this._snackBar.open("Mail Notification Sent Successfully", "Dismiss", {
            duration: 6000,
          });
        }   
      });
  }

  uploadPdfFile(mailData){
    this._dataService.uploadPdfFunc(mailData.imageFile[0]).subscribe((_resp: any)  => { 
      if (_resp.status == "OK") {

        this.sendMail(mailData);
      
      }
     })
  }

  getEqpPanel(_ssoData , _opt){
    let _eqName = "";
    for (let i = 0; i < _ssoData.length; i++) {
      let _ssoNo = _ssoData[i];
      let sub = this.pmCommercialObj.parentSORef.subSalesOrder;
      if(i > 0 && i <= _ssoData.length-1){
        if(_opt == 1){
        _eqName+= " <br/> ";
        }
        if(_opt == 2){
          _eqName+= " / ";
          }
      }
      for (let j = 0; j < sub.length; j++) {
        let _tmpNo = sub[j].pmTechSubSalesOrder.subOrderNo;
        if(_ssoNo == _tmpNo){
          if(_opt == 1){
            _eqName+= sub[j].pmTechSubSalesOrder.boardname;
          }
          if(_opt == 2){
            _eqName+= sub[j].pmTechSubSalesOrder.panelQuantity;
          }
        }
      }
    }
    return _eqName;
  }
  showCallLetValidation() {
    let _validList: Array<ValidationItem> = [];
    _validList.push(new ValidationItem("FAT Date for Call Letter ", (this.pmCommercialObj.fatCallLetterDate ? true : false), " required to generate Call Letter."));
    _validList.push(new ValidationItem("No. of Working Days ", (this.pmCommercialObj.workDaysNo ? true : false), " required to generate Call Letter."));
    _validList.push(new ValidationItem("Customer PO No", (this.pmCommercialObj.customerPoNo ? true : false), " required to generate Call Letter."));
    _validList.push(new ValidationItem("PO Date", (this.pmCommercialObj.pmPoDate ? true : false), " required to generate Call Letter."));

    if (this.ssoData != "") {
      var _tmpdata = this.ssoData;
      for (let i = 0; i < _tmpdata.length; i++) {
        let _ssoNo = _tmpdata[i];
        let sub = this.pmCommercialObj.parentSORef.subSalesOrder;
        for (let j = 0; j < sub.length; j++) {
          let _tmpNo = sub[j].pmTechSubSalesOrder.subOrderNo;
          if (_ssoNo == _tmpNo) {
            let _bname = sub[j].pmTechSubSalesOrder.boardname;
            _validList.push(new ValidationItem("Board Name - " + _tmpNo, (_bname ? true : false), " required to generate Call Letter."));
          }
        }
      }
    }
    else {
      _validList.push(new ValidationItem("Sub Order No/s", (this.ssoModel != "" ? true : false), " required to generate Call Letter."));
    }  

    let vSummaryObj: ValidationSummary = new ValidationSummary("Validation Summary.", _validList);
    this.dialog.open(ValidationDialog, {
      width: '50%',
      data: vSummaryObj
    });
  }
  readyForCallLetter(): boolean {
    if (this.pmCommercialObj.fatCallLetterDate && this.pmCommercialObj.workDaysNo && this.ssoModel != '' && this.pmCommercialObj.customerPoNo && this.pmCommercialObj.pmPoDate) {
      let _tmpB = [];
        var _tmpdata = this.ssoData;
      for (let i = 0; i < _tmpdata.length; i++) {
        let _ssoNo = _tmpdata[i];
        let sub = this.pmCommercialObj.parentSORef.subSalesOrder;
        for (let j = 0; j < sub.length; j++) {
          let _tmpNo = sub[j].pmTechSubSalesOrder.subOrderNo;
          if (_ssoNo == _tmpNo) {
            let _bname = sub[j].pmTechSubSalesOrder.boardname;
            _tmpB.push(_bname);
          }
        }
      }
      if ((!_tmpB.includes(undefined, 0)) && (!_tmpB.includes('', 0))) {
        return true;
      }
      else{
      } return false;

  }
    else {
      return false;
  }
  }
}
